<h1>Getting Started with Helios</h1>
<p>Welcome to Helios!</p>
<p>
  To get started, visit Workspaces and Panels in the upper right-hand corner of
  Helios. These tools will allow you to select and customize your preferred
  workspace so that you are ready to work every time you enter Helios.
</p>
<p>
  If you are new to Helios, please enroll in the Workday Learning Course
  <a
    href="https://www.myworkday.com/clearwateranalytics/learning/program/d776ac5791cf100160384825d2ae0000?type=2d29754fdb8e100008b50ff6bc94003b"
    target="_blank"
    class="links"
    >Getting Started in Helios</a
  >. This course has short videos and documents that walk through what you need
  to know to start working right away, and will answer most commonly asked
  questions about new concepts.
</p>

<p>
  If you have any feedback, or new features you would like to see, let us know
  in the
  <a
    href="https://teams.microsoft.com/l/channel/19%3A76af754c28464ac78803f1a7db0de288%40thread.skype/Recon%20Product%20Requests?groupId=2f8d05eb-2107-47f4-b4d8-21ef9577169b&tenantId=3dd59dce-9563-4ed5-b9aa-d0320fb1b440"
    target="_blank"
    class="links"
    >Recon Product Requests</a
  >
  Teams Channel.
</p>
